import { create } from 'zustand';
import { dossiersApi } from '@/api';

const useDossierStore = create((set, _get) => ({
  dossiers: [],
  total: 0,
  currentDossier: null,
  phaseProgress: null,
  loading: false,
  error: null,

  fetchDossiers: async (params = {}) => {
    set({ loading: true, error: null });
    try {
      const data = await dossiersApi.list(params);
      set({ dossiers: data.items, total: data.total, loading: false });
    } catch (error) {
      set({ error: error.message, loading: false });
    }
  },

  fetchDossier: async (id) => {
    set({ loading: true, error: null });
    try {
      const data = await dossiersApi.getComplet(id);
      set({ currentDossier: data, loading: false });
    } catch (error) {
      set({ error: error.message, loading: false });
    }
  },

  createDossier: async (data) => {
    set({ loading: true, error: null });
    try {
      const newDossier = await dossiersApi.create(data);
      set((state) => ({
        dossiers: [...state.dossiers, newDossier],
        total: state.total + 1,
        currentDossier: newDossier,
        loading: false,
      }));
      return newDossier;
    } catch (error) {
      set({ error: error.message, loading: false });
      throw error;
    }
  },

  updateDossier: async (id, data) => {
    set({ loading: true, error: null });
    try {
      const updated = await dossiersApi.update(id, data);
      set((state) => ({
        dossiers: state.dossiers.map((d) => (d.id === id ? updated : d)),
        currentDossier: state.currentDossier?.id === id ? updated : state.currentDossier,
        loading: false,
      }));
      return updated;
    } catch (error) {
      set({ error: error.message, loading: false });
      throw error;
    }
  },

  fetchPhaseProgress: async (id) => {
    try {
      const data = await dossiersApi.getPhaseProgress(id);
      set({ phaseProgress: data.phases });
      return data.phases;
    } catch {
      return null;
    }
  },

  validatePhase: async (id, phase) => {
    try {
      const updated = await dossiersApi.validatePhase(id, phase);
      // Refresh dossier and phase progress
      const dossier = await dossiersApi.getComplet(id);
      const progress = await dossiersApi.getPhaseProgress(id);
      set({
        currentDossier: dossier,
        phaseProgress: progress.phases,
      });
      return updated;
    } catch (error) {
      throw error;
    }
  },

  deleteDossier: async (id) => {
    set({ loading: true, error: null });
    try {
      await dossiersApi.delete(id);
      set((state) => ({
        dossiers: state.dossiers.filter((d) => d.id !== id),
        total: state.total - 1,
        currentDossier: state.currentDossier?.id === id ? null : state.currentDossier,
        loading: false,
      }));
    } catch (error) {
      set({ error: error.message, loading: false });
      throw error;
    }
  },
}));

export default useDossierStore;
